import script from "./BlogCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogCard.vue?vue&type=script&setup=true&lang=js"

import "./BlogCard.vue?vue&type=style&index=0&id=309af457&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-309af457"]])

export default __exports__